export const PlaneIcon = ({ color = "#DBBE78", size = 16, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M14.6666 10.6667V9.33337L8.99992 6.00004V2.33337C8.99992 1.78004 8.55325 1.33337 7.99992 1.33337C7.44658 1.33337 6.99992 1.78004 6.99992 2.33337V6.00004L1.33325 9.33337V10.6667L6.99992 9.00004V12.6667L5.33325 13.6667V14.6667L7.99992 14L10.6666 14.6667V13.6667L8.99992 12.6667V9.00004L14.6666 10.6667Z"
            fill={color}
        />
    </svg>
);
